import { Location } from '@cobliteam/common-types';
import { lazy } from '@cobliteam/lazy-with-retries';

const BasicValuePage = lazy(() => import('../../pages/BasicValuePage/BasicValuePage'));

const routes = [
  {
    path: Location.BASIC_VALUE,
    component: BasicValuePage,
    exact: true,
  },
];

export default routes;
